/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Notice_TitleInputs */

const en_directory_promotion_notice_title = /** @type {(inputs: Directory_Promotion_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing is a preview`)
};

const zh_directory_promotion_notice_title = /** @type {(inputs: Directory_Promotion_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前价格仅供预览`)
};

/**
* | output |
* | --- |
* | "Pricing is a preview" |
*
* @param {Directory_Promotion_Notice_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_notice_title = /** @type {((inputs?: Directory_Promotion_Notice_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Notice_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_notice_title(inputs)
	return zh_directory_promotion_notice_title(inputs)
});
export { directory_promotion_notice_title as "directory.promotion.notice_title" }